import React, { memo } from "react";

import { classNames } from "helpers";

import { ShowcaseNoticeProps } from "./types";

/** Sadržaj male obavijesti na pozornici: ikona u kvadratiću i dva reda teksta. */
const ShowcaseNotice: React.FC<ShowcaseNoticeProps> = ({ title, subtitle, icon, iconClassName }) => {
  return (
    <div className="flex items-center gap-3 px-4 py-3.5">
      <span
        className={classNames(
          "flex items-center justify-center w-9 h-9 rounded-lg flex-shrink-0 overflow-hidden",
          iconClassName
        )}
      >
        {icon}
      </span>
      <div className="min-w-0">
        <div className="text-[0.7rem] font-bold text-slate-800 truncate">{title}</div>
        <div className="text-[0.65rem] text-slate-400 truncate">{subtitle}</div>
      </div>
    </div>
  );
};

export default memo(ShowcaseNotice);
